export default __webpack_public_path__ + "css/userRemoved.bundle.css";